import { Component, forwardRef, Input, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Slider } from 'primeng/slider';

@Component({
  selector: 'app-amount-slider',
  templateUrl: './amount-slider.component.html',
  styleUrls: ['./amount-slider.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AmountSliderComponent),
      multi: true,
    },
  ],
})
export class AmountSliderComponent implements ControlValueAccessor {
  @ViewChild(Slider, { static: true })
  public slider!: Slider;

  @Input() min: number = 0;
  @Input() max: number = 100;
  @Input() step: number = 1;

  public writeValue(value: null) {
    this.slider.writeValue(value);
  }

  public setDisabledState(isDisabled: boolean): void {
    this.slider.setDisabledState(isDisabled);
  }

  public registerOnChange(fn: any): void {
    this.slider.registerOnChange(fn);
  }

  public registerOnTouched(fn: any): void {
    this.slider.registerOnTouched(fn);
  }
}
